import React, { useMemo } from 'react'
import Error from 'images/inline/spot-the-diff/error.svg'
import {
  MODAL_WIN_TITLE,
  MODAL_WIN_SUBTITLE,
  MODAL_LOSE_TITLE,
  MODAL_LOSE_SUBTITLE,
  MODAL_AT_LEAST_ONE_WIN_TITLE,
  MODAL_AT_LEAST_ONE_WIN_SUBTITLE,
} from 'steps/spot-the-diff/constants'

const CompletionSummary = ({
  isWin = false,
  onClose,
  totalScenes,
  wonScenes,
  lastScene,
}) => {
  const [summary, summarySubtitle] = useMemo(() => {
    if (isWin) {
      return [MODAL_WIN_TITLE, MODAL_WIN_SUBTITLE]
    } else if (lastScene && totalScenes > 1 && wonScenes > 0) {
      return [
        MODAL_AT_LEAST_ONE_WIN_TITLE,
        MODAL_AT_LEAST_ONE_WIN_SUBTITLE({ wonScenes, totalScenes }),
      ]
    } else {
      return [MODAL_LOSE_TITLE, MODAL_LOSE_SUBTITLE]
    }
  }, [isWin, lastScene, totalScenes, wonScenes])

  return (
    <div className="summary-modal">
      <div className="summary-modal__header">
        {!lastScene && (
          <button className="modal__button" onClick={onClose}>
            <Error />
          </button>
        )}
      </div>
      <div className="completion__summary">
        <div className="summary-modal__title">{summary}</div>
        <div className="summary-modal__text">{summarySubtitle}</div>
      </div>
    </div>
  )
}

export default CompletionSummary
